import BrowseDuperContext from './BrowseDuperContext';
import BrowseDuperContextContainer from './BrowseDuperContext.container';

export default BrowseDuperContextContainer(BrowseDuperContext);
